<template>
  <div>
    <label
      v-if="label"
      class="pl-2 label-text"
    >
      {{ label }}
      <v-icon
        v-if="required"
        class="uikit-icon mini-star size-mini-star error"
      />
    </label>
    <v-text-field
      class="rounded-lg mt-0 mini-text field-edit"
      v-model="dataValue"
      outlined
      dense
      :height="20"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :class="errorMessages && errorMessages.length ? 'field-error' : ''"
      :hide-details="hideDetails && !hint"
      :error-messages="errorMessages"
      :hint="hint"
      :persistent-hint="persistentHint"
      @change="change"
      @input="input"
    />
  </div>
</template>

<script>
import { getNormalizedNumberFromString } from '@/scripts'

export default {
  name: 'UITextField',

  props: {
    label: String,
    value: {
      type: String | Number | null | undefined,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    useVmaskForNumber: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: true
    }
  },

  data: () => {
    return {
      dataValue: null
    }
  },

  methods: {
    change(val) {
      this.$emit('change', this.type === 'number' || this.useVmaskForNumber ? getNormalizedNumberFromString(val) : val)
    },
    input(val) {
      this.$emit('input', this.type === 'number' || this.useVmaskForNumber ? getNormalizedNumberFromString(val) : val)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    }
  }
}
</script>

<style scoped></style>
